import accComparePlot from "../../../../content/posts/data-release-notes/gm24385_2021.05/accuracy.compare.jsx";
import qComparePlot from "../../../../content/posts/data-release-notes/gm24385_2021.05/qscore.compare.jsx";
import qFilterPlot from "../../../../content/posts/data-release-notes/gm24385_2021.05/qscore.filter.jsx";
import * as React from 'react';
export default {
  accComparePlot,
  qComparePlot,
  qFilterPlot,
  React
};